import Root from './label.svelte';

export {
  //
  Root as Label,
  Root
};
